import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ErrorBoundary from './components/ErrorBoundary';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { AuthProvider } from './contexts/AuthContext';
import { HeartProvider } from './contexts/HeartContext';
import MainPage from './pages/MainPage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import NormalRegistrationPage from './pages/NormalRegistrationPage';
import ProfileRegistrationPage from './pages/ProfileRegistrationPage';
import KakaoRegistrationPage from './pages/KakaoRegistrationPage';
import KakaoCallbackPage from './pages/KakaoCallbackPage';
import DashboardPage from './pages/DashboardPage';
import NewDashboardPage from './pages/Dashboard/DashboardPage';
import ChatPage from './pages/ChatPage';
import MessagesPage from './pages/Messages/MessagesPage';
import AdminMainPage from './pages/admin/AdminMainPage';
import AdminUsersPage from './pages/admin/AdminUsersPage';
import AdminUserDetailPage from './pages/admin/AdminUserDetailPage';
import AdminChatsPage from './pages/admin/AdminChatsPage';
import AdminReportsPage from './pages/admin/AdminReportsPage';
import AdminCupidCardsPage from './pages/admin/AdminCupidCardsPage';
import AdminProfileReviewsPage from './pages/admin/AdminProfileReviewsPage';
import AdminProfileReviewDetailPage from './pages/admin/AdminProfileReviewDetailPage';
import AdminInquiriesPage from './pages/admin/AdminInquiriesPage';
import AdminAppealsPage from './pages/admin/AdminAppealsPage';
import AdminFaqPage from './pages/admin/AdminFaqPage';
import HeartPurchasePage from './pages/HeartPurchasePage';
import WalletDetailPage from './pages/WalletDetailPage';
import HeartPolicyPage from './pages/Policy/HeartPolicyPage';
import IdentityVerificationPage from './pages/IdentityVerification/IdentityVerificationPage';
import TermsPage from './pages/Terms/TermsPage';
import SettingsPage from './pages/Settings/SettingsPage';
import SupportPage from './pages/Support/SupportPage';
import InquiryFormPage from './pages/Support/InquiryFormPage';
import InquiryListPage from './pages/Support/InquiryListPage';
import InquiryDetailPage from './pages/Support/InquiryDetailPage';
import ReportPage from './pages/Support/ReportPage';
import AppealFormPage from './pages/Support/AppealFormPage';
import AppealListPage from './pages/Support/AppealListPage';
import AppealDetailPage from './pages/Support/AppealDetailPage';
import SanctionNoticePage from './pages/Support/SanctionNoticePage';
import SanctionBlockPage from './pages/Support/SanctionBlockPage';
import NotificationsPage from './pages/Notifications/NotificationsPage';
import ProtectedRoute from './components/ProtectedRoute';
import { goldenAfternoonTheme } from './theme';

function App() {
  return (
    <ErrorBoundary>
      <ThemeProvider theme={goldenAfternoonTheme}>
        <CssBaseline />
        <AuthProvider>
          <HeartProvider>
            <Router>
            <Routes>
              <Route path="/" element={<MainPage />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/register" element={<RegisterPage />} />
              <Route path="/register/normal" element={<NormalRegistrationPage />} />
              <Route path="/register/profile" element={<ProfileRegistrationPage />} />
              <Route path="/kakao-registration" element={<KakaoRegistrationPage />} />
              <Route path="/kakao/callback" element={<KakaoCallbackPage />} />
              {/* 제재 차단 화면 (제재 상태에서 접근 가능) */}
              <Route path="/sanction-block" element={<SanctionBlockPage />} />
              <Route path="/appeal" element={<AppealFormPage />} />
              <Route path="/appeal/list" element={<AppealListPage />} />
              <Route path="/appeal/:id" element={<AppealDetailPage />} />
              <Route path="/support/sanction" element={<SanctionNoticePage />} />

              {/* 핵심 서비스 라우트 (SUSPENDED/BANNED 접근 차단) */}
              <Route element={<ProtectedRoute />}>
                <Route path="/dashboard" element={<DashboardPage />} />
                <Route path="/dashboard-new" element={<NewDashboardPage />} />
                <Route path="/chat/:cardId" element={<ChatPage />} />
                <Route path="/messages" element={<MessagesPage />} />
                <Route path="/messages/:conversationId" element={<MessagesPage />} />
                <Route path="/heart/purchase" element={<HeartPurchasePage />} />
                <Route path="/wallet" element={<WalletDetailPage />} />
                <Route path="/settings" element={<SettingsPage />} />
                <Route path="/report" element={<ReportPage />} />
                <Route path="/notifications" element={<NotificationsPage />} />
              </Route>

              <Route path="/policy/hearts" element={<HeartPolicyPage />} />
              <Route path="/identity-verification" element={<IdentityVerificationPage />} />

              {/* 약관 열람 라우트 */}
              <Route path="/terms/:type" element={<TermsPage />} />

              {/* 고객센터 라우트 */}
              <Route path="/support" element={<SupportPage />} />
              <Route path="/support/inquiry" element={<InquiryFormPage />} />
              <Route path="/support/inquiry/list" element={<InquiryListPage />} />
              <Route path="/support/inquiry/:id" element={<InquiryDetailPage />} />

              {/* Admin Routes */}
              <Route path="/admin" element={<AdminMainPage />} />
              <Route path="/admin/users" element={<AdminUsersPage />} />
              <Route path="/admin/users/:userId" element={<AdminUserDetailPage />} />
              <Route path="/admin/chats" element={<AdminChatsPage />} />
              <Route path="/admin/reports" element={<AdminReportsPage />} />
              <Route path="/admin/cupid-cards" element={<AdminCupidCardsPage />} />
              <Route path="/admin/profile-reviews" element={<AdminProfileReviewsPage />} />
              <Route path="/admin/profile-reviews/:id" element={<AdminProfileReviewDetailPage />} />
              <Route path="/admin/inquiries" element={<AdminInquiriesPage />} />
              <Route path="/admin/appeals" element={<AdminAppealsPage />} />
              <Route path="/admin/faqs" element={<AdminFaqPage />} />
            </Routes>
            </Router>
          </HeartProvider>
        </AuthProvider>
      </ThemeProvider>
    </ErrorBoundary>
  );
}

export default App;
